<template>
	<div class="qingwu">
		<div class="admin_main_block">
			<div class="admin_main_block_top">
				<div class="admin_main_block_left">
					<!-- <div><router-link to="/Admin/withdrawal/userlogform"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div> -->
					<div><el-input v-model="phone" placeholder="请输入用户手机号码"></el-input></div>
					
					<div><el-button icon="el-icon-search" @click="get_cash_list">条件筛选</el-button></div>
				</div>

				<!-- <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div> -->
			</div>

			<div class="admin_table_main">
				<el-table :data="list" @selection-change="handleSelectionChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column>
					<el-table-column prop="user" label="用户信息">
						<template slot-scope="scope">
							<div v-if="scope.row.user">
								<div class="table-row">
									<span>用户头像：</span>
									<el-avatar shape="circle" :size="30" :src="scope.row.user.F_VR_TOUX"></el-avatar>
								</div>
								<div class="table-row">
									<span>用户昵称：</span>
									<span>{{scope.row.user.F_VR_NIC}}</span>
								</div>
								<div class="table-row">
									<span>用户ID：</span>
									<span>{{scope.row.user.id}}</span>
								</div>
								<div class="table-row">
									<span>用户手机号码：</span>
									<span>{{scope.row.user.phone}}</span>
								</div>
							</div>
							<span v-else>
								账号不存在(删除/注销)
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="封禁原因"></el-table-column>
					<el-table-column prop="add_time" label="封禁时间"></el-table-column>
					<!-- <el-table-column label="操作" fixed="right" width="100px">
						<template slot-scope="scope">
							<el-button icon="el-icon-edit"
								@click="state_status(scope.row.user_id)">解封</el-button>
						</template>
					</el-table-column> -->
				</el-table>
				<div class="admin_table_main_pagination">
					<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total"
						:total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				phone: '',
				list: [],
				total_data: 0, // 总条数
				page_size: 20,
				current_page: 1,
				select_id: '',
			};
		},
		watch: {},
		computed: {},
		methods: {
			handleSelectionChange: function(e) {
				let ids = [];
				e.forEach(v => {
					ids.push(v.id);
				});
				this.select_id = ids.join(',');
			},
			get_cash_list: function() {
				let _this = this;
				this.$get(this.$api.ecmpLog, {
					page: this.current_page,
					phone: this.phone,
				}).then(function(res) {
					_this.page_size = res.data.per_page;
					_this.total_data = res.data.total;
					_this.current_page = res.data.current_page;
					_this.list = res.data.data;
				})

			},
			// 分页改变
			current_change: function(e) {
				this.current_page = e;
				this.get_cash_list();
			},
			// 指定ID修改状态
			state_status: function(id) {
				this.$post(this.$api.stateStoretStatus, {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
					} else {
						this.$message.success('操作失败');
					}
					this.get_cash_list();
				});
			}
			// 删除处理
			// del:function(id){
			//     let _this = this;
			//     if(this.$isEmpty(id)){
			//         return this.$message.error('请先选择删除的对象');
			//     }
			//     this.$post(this.$api.withdrawalDel,{id:id}).then(function(res){
			//         if(res.code == 200){
			//             _this.get_cash_list();
			//             return _this.$message.success("删除成功");
			//         }else{
			//             return _this.$message.error("删除失败");
			//         }
			//     });
			// },
		},
		created() {
			this.get_cash_list();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
.table-row{
	display: flex;
	flex-direction: row;
	align-items: center;
}
</style>